import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DialogService, MsgBoxItems } from './dialog.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit,AfterViewInit {
  showDialog = false;
  dialogMsg: MsgBoxItems = { msg: "", title: "", buttonType: "Ok"};
  subsMsgItem!: Subscription;
  buttons= {
    "Ok": ["Ok"],
    "YesNo": ["Yes", "No"],
    "OkCancel": ["Ok", "Cancel"],
    "YesNoCancel": ["Yes", "No", "Cancel"],
    "tag": ["Back to Search Page"],
    "ref":['Search'],
    "send":["Cancel",'Change Number','Send'],
    "sendEmail":["Cancel",'Change Email Id','Send'],
    "priceChange":["Back to Search Page",'Accept']


  }
  constructor(private dialogService: DialogService) {
    this.subsMsgItem = this.dialogService.getMsgSub().subscribe(msgItem => {
      this.dialogMsg = msgItem;
      this.showDialog = true;
    })
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    /*  $.getScript("../../../assets/scripts/move.js", function () {
    });*/
  }
  onBtnClick(btnType: string) {
    this.showDialog = false;
    this.dialogService.result(btnType);
  }

}
